module.exports = __webpack_public_path__ + "img/Play.e1629aa6.svg";